import { useEffect } from 'react';
import React from 'react';

import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { Flex, Text, Icon } from '@chakra-ui/react';
import { BiMap } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';

import PostCard from './PostCard';
import OpenHours from './OpenHours';
import Socials from './Socials';
import { setRestaurantID } from '../../Redux/Actions/Actions';
import LoadingScreen from '../LoadingScreen';
import { cookies } from '../../CookiesHandler/cookies';
import NotFound from './NotFound';

import './Styles/Home.css';


const mapDispatchToProps = (dispatch) => {
    return {
        setID: (id) => {
            dispatch( setRestaurantID(id) );
        }
    }
}
const mapStateToProps = (state) => {
    return {
        restaurantID: state.restaurantID,
        restaurantName: state.restaurantName,
        categories: state.categories,
        itemsByCategories: state.itemsByCategories,
        restaurantInfo: state.restaurantInfo,
        posts: state.posts,
        restaurantNotFound: state.restaurantNotFound,
    }
}

const HomePage = (props) => {

    const Cover = React.memo(function Cover({ src, alt }) {
        return <img src={src} alt={alt} className="cover" />;
    });

    const { cover, address, description, facebook, instagram, icon, phone, website, openHours } = props.restaurantInfo || {};
    const lang = cookies.get('i18next');    

    let atLeastOneOpenHour = false;
    let atLeastOneVisiblePost = false;

    if( openHours )
        atLeastOneOpenHour = ( Object.values( openHours )?.reduce( (tot_len, day_i) => tot_len + day_i.toString().length, 0 ) > 0);

    if( props.posts ) {
        atLeastOneVisiblePost = ( props.posts.reduce( (accumulatedVal, post) => (accumulatedVal || post.visible)
        , false ) );
    }
    
    const { t } = useTranslation();

    let { id } = useParams();
    let { setID } = props;
    let currentlySavedID = props.restaurantID;

    useEffect( ()=>{
        if( ! currentlySavedID )
            setID( id );
    }, [id, currentlySavedID, setID]);

    const postsSection = props.posts?.map( (post) => {
        return post.visible ? 
            <PostCard ml={3} mr={3} date={post.data} image={post.image} 
                      title={post.text} key={post.postKey} avatar={icon} 
                      name={props.restaurantName} content={post.description || null}/> 
            : null
    } )
    
    const schermata = ( !props.categories || !props.restaurantName ) ? 
    
    props.restaurantNotFound ? <NotFound /> :
    <section style={{height: "100vh", width: "100%", backgroundColor: "#FFF", position: "fixed", top: "0", left: "0", zIndex: "2"}}>
        <LoadingScreen />
    </section>
    :
    <>
        <Flex minWidth="100vmin" overflow="hidden" justifyContent="center" w="100%" direction="column" mt="62px" mb="58px">
            { cover && <Cover alt={description} src={cover}/> }

            <Text color="lightblack" fontWeight="bold" fontSize="2xl" mt={cover ? 4:1} pl={4}>
                {props.restaurantName }
            </Text>
            <Text color="darkerGrey" fontWeight="normal" fontSize="normal" pl={4} lineHeight={5}>
                {description}
            </Text>
            <Flex width="90%" alignItems="center" ml={4} mt={4}>
                <Icon as={BiMap} w={6} h={6} color="highlight" ml={0} mt={0}/>
                <Text ml={2} color="lightblack" textTransform="capitalize">
                    { 
                    
                    lang === 'it'? 
                    "Via " + address.street + ' '+ address.streetNumber + " - " + address.city + " (" + address.province + ")"
                    :
                    address.street + ' Street, '+ address.streetNumber + " - " + address.city + " (" + address.province + ")"
                    
                    }
                </Text>
            </Flex>
            
            { atLeastOneOpenHour &&  <OpenHours timeTable={openHours}/> }
            
            <Socials facebook={facebook} instagram={instagram} phone={phone} website={website}/>

            { atLeastOneVisiblePost &&
            <>
                <Text fontSize="xl" fontWeight="medium" mt={2} ml={4}>
                    {t("ourEvents")}
                </Text>

                { postsSection }
             </>
             }
        </Flex>
    </>
    
    return schermata;
}
  

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);